import type { NodeDefinition } from '../../../types/node-definition';

const definition: NodeDefinition = {
  type: 'access-charity-crm',
  name: 'Access Charity CRM',
  category: 'access-integrations',
  description: 'Integrate with Access thankQ CRM for charity management - actions, communications, contacts, and attachments',
  icon: 'Heart',
  color: 'purple',
  version: '1.0.0',
  inputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Input',
      required: true,
    },
  ],
  outputs: [
    {
      name: 'default',
      type: 'main',
      displayName: 'Output',
    },
  ],
  credentials: [
    {
      name: 'accessCharityCrm',
      required: true,
    },
  ],
  tags: ['access', 'charity', 'crm', 'thankq', 'donations', 'fundraising', 'communications'],

  // Tool-capable configuration for AI Agent integration
  toolCapable: {
    enabled: true,
    name: 'access_charity_crm',
    description: 'Interact with Access Charity CRM (thankQ) to manage actions, communications, contact addresses, and attachments for charity donor management',
    allowManualDescription: false,
    parameters: {
      action: {
        toolParamName: 'action',
        description: 'The operation to perform: listActions, getAction, createAction, updateAction, listCommunications, getCommunication, createCommunication, updateCommunication, listContactAddresses, getContactAddress, createContactAddress, deleteContactAddress, listAttachments, getAttachment, createAttachment, deleteAttachment, healthCheck',
        required: true,
        type: 'string',
      },
      actionRef: {
        toolParamName: 'actionRef',
        description: 'Action reference ID (required for getAction, updateAction)',
        required: false,
        type: 'string',
      },
      communicationId: {
        toolParamName: 'communicationId',
        description: 'Communication ID (required for getCommunication, updateCommunication)',
        required: false,
        type: 'string',
      },
      contactAddressId: {
        toolParamName: 'contactAddressId',
        description: 'Contact address ID (required for getContactAddress, deleteContactAddress)',
        required: false,
        type: 'string',
      },
      attachmentRef: {
        toolParamName: 'attachmentRef',
        description: 'Attachment reference (required for getAttachment, deleteAttachment)',
        required: false,
        type: 'string',
      },
      page: {
        toolParamName: 'page',
        description: 'Page number for list operations (default: 1)',
        required: false,
        type: 'number',
      },
      pageSize: {
        toolParamName: 'pageSize',
        description: 'Results per page (default: 50, max: 1000)',
        required: false,
        type: 'number',
      },
      subject: {
        toolParamName: 'subject',
        description: 'Contact reference for filtering or creating action records',
        required: false,
        type: 'string',
      },
      contactRef: {
        toolParamName: 'contactRef',
        description: 'Contact reference for communications and addresses',
        required: false,
        type: 'string',
      },
      body: {
        toolParamName: 'body',
        description: 'Full request body for create/update operations (JSON object)',
        required: false,
        type: 'object',
      },
    },
    outputMapping: {
      success: 'Whether the operation succeeded',
      action: 'The action that was performed',
      data: 'The response data from the API',
      pageInfo: 'Pagination information for list operations',
    },
  },
};

export default definition;
